import { render, staticRenderFns } from "./update-productcategory.vue?vue&type=template&id=43a59f82"
import script from "./update-productcategory.vue?vue&type=script&lang=ts"
export * from "./update-productcategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports